import { Box, Typography } from "@mui/material";
import { CSSProperties, ReactNode } from "react";

interface Props {
  variant: "h1" | "h2" | "h3" | "h4" | "h5";
  children?: ReactNode;
  style?: CSSProperties;
  className?: string;
  dangerouslySetInnerHTML?: { __html: string };
}

const Title = ({ children, variant = "h1", style, className = "", dangerouslySetInnerHTML }: Props) => {
  const html = dangerouslySetInnerHTML ?? (typeof children === 'string' ? { __html: children } : null);
  return (
    <Box className={`Title ${className}`} style={style}>
      {html
        ? <Typography variant={variant} dangerouslySetInnerHTML={html} />
        : <Typography variant={variant}>{children}</Typography>
      }
    </Box>
  );
};

export default Title;
